/**
 * OrnamentDivider: a rule with two olive leaves and a berry at its centre.
 * Marks a break in an evening. Decorative, so hidden from assistive technology.
 */
import React from 'react';
import { clsx } from 'clsx';

const OrnamentDivider = ({ id, className }) => (
  <div id={id} className={clsx('flex items-center gap-3 my-8', className)} aria-hidden="true">
    <div className="flex-1 h-px bg-courtyard-gold/30" />
    <svg
      width="46"
      height="12"
      viewBox="0 0 46 12"
      className="flex-shrink-0 text-courtyard-gold"
      focusable="false"
    >
      <path d="M1 6 C7 0.6 14 0.6 19 6 C14 11.4 7 11.4 1 6 Z" fill="currentColor" />
      <path d="M45 6 C39 0.6 32 0.6 27 6 C32 11.4 39 11.4 45 6 Z" fill="currentColor" />
      <circle cx="23" cy="6" r="2.3" fill="currentColor" />
    </svg>
    <div className="flex-1 h-px bg-courtyard-gold/30" />
  </div>
);

export default OrnamentDivider;
